// extracted by mini-css-extract-plugin
export default {"button":"ToggleButton-module__button__Cohvx","icon":"ToggleButton-module__icon__wxFtO"};